import React from 'react';
import '../styles/HomePage.css';

function HomePage() {
  return (
    <div className="homepage-container">
      <div className="homepage-text">
        <h2>Bem-vindo à Bem te Vejo</h2>
        <p>
          A bem te vejo é uma aplicação que provê informações e análises sobre postagens obtidas da rede social Reddit sobre depressão.
        </p>
        <p>
          Por meio da bem te Vejo é possível obter insights dos dados textuais coletados, buscando padrões relevantes ao entendimento de como o tema da depressão foi discutido pelos usuários na rede, considerando três diferentes períodos associados à pandemia de COVID-19: antes, durante e depois.
        </p>
      </div>
    </div>
  );
}

export default HomePage;
